import { Component, OnInit } from '@angular/core';
import { ReportesService } from 'src/app/services/reportes/reportes.service';
import * as XLSX from 'xlsx';
import swal2 from 'sweetalert2';
import { UsuarioService } from 'src/app/services/service.index';
import { CatalogosService } from 'src/app/services/catalogos/catalogos.service';

@Component({
  selector: 'app-reporte-cotizaciones',
  templateUrl: './reporte-cotizaciones.component.html',
  styleUrls: ['./reporte-cotizaciones.component.css']
})
export class ReporteCotizacionesComponent implements OnInit {

  cols = [
    {field: 'quote_folio', header: 'Folio cotización'},
    {field: 'date', header: 'Fecha'},
    {field: 'total', header: 'Total'},
    {field: 'name', header: 'Nombre vendedor'},
    {field: 'email', header: 'Correo vendedor'},
    {field: 'estado', header: 'Estado'},
  ];

  quotes = [];
  filteredQuotes = [];

  sortColumn: string = ''; // Columna actual de ordenación
  sortDirection: 'asc' | 'desc' = 'asc'; // Dirección de ordenación
  currentPage: number = 1;
  itemsPerPage: number = 10;
  searchTerm: string = '';
  maxVisiblePages: number = 8; // Número máximo de páginas visibles
  searchTerms = {
    quote_folio: '',
    date: '',
    total: '',
    name: '', 
    mail: '',
    estado: '', 
  };

  opcionSeleccionada = 'todas';
  vendedores = [];
  doctores = [];
  fechaInicial = '';
  fechaFinal = '';

  constructor(private reportesService: ReportesService,
              private usuariosService: UsuarioService,
              private catalogosService: CatalogosService
  ) { }

  ngOnInit(): void {
    this.usuariosService.getUsuariosVendedores().subscribe(resp => {
      this.vendedores = resp;
    })
    this.catalogosService.getDoctores().subscribe(resp => {
      this.doctores = resp;
    })
    this.consultarQuotes();
  }

  formatearFecha(fecha: Date): string {
    const año = fecha.getFullYear();
    const mes = fecha.getMonth() + 1; // Los meses van de 0 a 11
    const día = fecha.getDate();
    return `${año}-${mes}-${día}`;
  }

  consultaQuotesFechas(){
    this.consultarQuotes(this.fechaInicial, this.fechaFinal);
    this.fechaInicial = '';
    this.fechaFinal = '';
  }

  consultarQuotes(parametro?, parametro2?) {
    this.quotes = [];
    this.reportesService.reportQuotes(this.opcionSeleccionada, parametro, parametro2).subscribe(resp => {
      this.quotes = JSON.parse(JSON.stringify(resp));
      this.quotes.forEach(q => {
        switch (q.status) {
          case 'PA':
            q.estado = 'Pendiente';
            break;
          case 'AP':
            q.estado = 'Aceptada';
            break;
          case 'AC':
            q.estado = 'Aprobada';
            break;
          case 'RE':
            q.estado = 'Rechazada';
            break;
          default:
            q.estado = 'Desconocido';
            break;
        }
      })
    })
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }
  
  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
  
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }
  
  goToEllipsisPage(position: 'first' | 'last'): void {
    if (position === 'first') {
      this.currentPage = 1;
    } else if (position === 'last') {
      this.currentPage = this.totalPages;
    }
  }

  get totalPages(): number {
    return Math.ceil(this.filteredDataq.length / this.itemsPerPage);
  }

  get pages(): number[] {
    const totalPages = this.totalPages;
  
    if (totalPages <= this.maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
  
    const pages = [];
    const halfRange = Math.floor(this.maxVisiblePages / 2);
  
    let startPage = Math.max(1, this.currentPage - halfRange);
    let endPage = Math.min(totalPages, startPage + this.maxVisiblePages - 1);
  
    if (endPage === totalPages) {
      startPage = totalPages - this.maxVisiblePages + 1;
    }
    if (startPage === 1) {
      endPage = this.maxVisiblePages;
    }
  
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
  
    return pages;
  }

  pgone() {
    this.currentPage = 1;
  }

  sortData(column: string): void {
    // Cambia la dirección de ordenación si se selecciona la misma columna, de lo contrario reinicia a ascendente
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  }

  private compare(a: any, b: any, column: string, direction: 'asc' | 'desc'): number {
    if (!column) return 0;
  
    const valueA = a[column];
    const valueB = b[column];
  
    let comparison = 0;
    if (valueA > valueB) {
      comparison = 1;
    } else if (valueA < valueB) {
      comparison = -1;
    }
  
    return direction === 'asc' ? comparison : -comparison;
  }

  exportExcelFil() {
    let fullData = this.filteredDataq
    const readOpts = {
        cellText: false, 
        cellDates: true,
    };
   // Generar los datos personalizados para exportación
   const dataToExport = fullData.map(item => ({
    'Folio cotización': item.quote_folio || '',
    'Fecha': this.formatFecha(item.date) || '',
    'Total': this.removeCommas(item.total) || '',
    'Nombre vendedor': item.user_vendor.name || '',
    'Correo vendedor': item.user_vendor.email || '',
    'Estado': item.estado || '',
  }));
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport, readOpts);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'cotizaciones.xlsx', readOpts);
  }

  formatFecha(fecha: { split: (arg0: string) => [any, any, any]; }) {
    if (!fecha) return '';
    const [year, month, day] = fecha.split('-');
    return `${day}/${month}/${year}`;
  }
  
  removeCommas(monto: { toString: () => string; }) {
    if (!monto) return '';
    return monto.toString().replace(/,/g, ''); // Elimina todas las comas
  }

  get filteredDataq(): any[] {
    const filtered = this.quotes.filter(item => //return
      (!this.searchTerms.quote_folio || (item.quote_folio && item.quote_folio.toLowerCase().includes(this.searchTerms.quote_folio.toLowerCase()))) &&
      (!this.searchTerms.date || (item.date && item.date.toLowerCase().includes(this.searchTerms.date.toLowerCase()))) &&
      (!this.searchTerms.name || (item.user_vendor.name && item.user_vendor.name.toLowerCase().includes(this.searchTerms.name.toLowerCase()))) &&
      (!this.searchTerms.mail || (item.user_vendor.mail && item.user_vendor.mail.toLowerCase().includes(this.searchTerms.mail.toLowerCase()))) &&
      (!this.searchTerms.total || (item.total && item.total.toLowerCase().includes(this.searchTerms.total.toLowerCase()))) &&
      (!this.searchTerms.estado || (item.estado && item.estado.toLowerCase().includes(this.searchTerms.estado.toLowerCase()))) 
    );
    return filtered.sort((a, b) => this.compare(a, b, this.sortColumn, this.sortDirection));
  }

  get dataToShow(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.filteredDataq.slice(startIndex, startIndex + this.itemsPerPage);
  }

}
